var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/User.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { ApiDomain } from './domain';
export var User;
(function (_User) {
  var domain = ApiDomain.domain('User', {
    name: "domain",
    sid: "-jz58pn"
  });
  var Role = _User.Role = t.type({
    id: t.string,
    name: t.string,
    description: t.union([t.string, t["null"], t.undefined]),
    containerId: t.string,
    clientRole: t["boolean"],
    composite: t["boolean"]
  });
  var User = _User.User = t.intersection([t.type({
    id: t.string
  }), t.partial({
    username: t.string,
    email: t.string,
    emailVerified: t["boolean"],
    enabled: t["boolean"],
    exact: t["boolean"],
    firstName: t.string,
    lastName: t.string,
    max: t.number,
    search: t.string
  })]);
  var fetchUserList = _User.fetchUserList = ApiCallService.create({
    name: 'fetchUserList',
    parentDomain: domain,
    result: t.array(User),
    getKey: []
  });
  var fetchRoleList = _User.fetchRoleList = ApiCallService.create({
    name: 'fetchRoleList',
    parentDomain: domain,
    result: t.array(Role),
    getKey: []
  });
})(User || (User = {}));